import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router";

import {
  buildLoginPath,
  getAuthReturnPath,
  resolvePostLoginPath,
  useToken,
} from "@/modules/auth";
import { isOnboardingPending } from "@/modules/onboarding/state";
import { dialogManager } from "@/shared/components/dialog";
import { ROUTE_PATHS } from "@/shared/constants/route-paths";

export function ProtectedRoute() {
  const location = useLocation();
  const token = useToken();

  useEffect(() => {
    if (!token && location.pathname.startsWith(ROUTE_PATHS.MINE)) {
      dialogManager.closeAll();
    }
  }, [location.pathname, token]);

  if (!token) {
    const returnPath = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate replace to={buildLoginPath(returnPath)} />;
  }

  return <Outlet />;
}

export function GuestRoute() {
  const location = useLocation();
  const token = useToken();

  if (token) {
    const returnPath = getAuthReturnPath(location.search);
    return (
      <Navigate
        replace
        to={resolvePostLoginPath({
          onboardingPending: isOnboardingPending(token),
          returnPath,
        })}
      />
    );
  }

  return <Outlet />;
}
